import client from './client'

const apiBasePath = '/api/admin/mst/company/'

export default {
  search: entryForm => client.post(apiBasePath + 'search', entryForm),
  detail: companyId => client.post(apiBasePath + 'detail', companyId),
  register: entryForm => client.post(apiBasePath + 'register', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm),
  delete: companyId => client.post(apiBasePath + 'delete', companyId)
}
